module.exports = __webpack_public_path__ + "d2e0fc8a53873598b2273fc2618f4d7f.svg";